export class NoiseCatalogFilterRequest {
    // searchTermMap?: Map<string,any[]>;
    seriesFilterList?: any[];
    areaFilterList?: any[];
    componentFilterList?: any[];
    drivingConditionFilterList?: any[];
    weatherConditionFilterList?: any[];
    kindOfNoiseFilterList?: any[];
    sporadicOrPermanent?: string;
    mainGroup?: string;
}